import { onPageLoad } from '../modules/page_lifecycle.js';
import { showModal } from '../modules/bootstrap_ui.js';

onPageLoad(() => {
  document.querySelectorAll('.webinar-non-subscriber-video-link').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      showModal('non-subscriber-video-modal');
    });
  });
});
